document.addEventListener('click', (event) => {
  // Target our updated button class
  const btn = event.target.closest('.f-scrolling-promotion__toggle');
  if (!btn) return;
  
  event.stopImmediatePropagation();

  const parent = btn.closest('.f-scrolling-promotion__wrapper');
  const carousel = parent ? parent.querySelector('f-scrolling-promotion') : null;
  
  if (carousel) {
    const isPaused = btn.getAttribute('aria-pressed') === 'true';
    const nextState = !isPaused;

    btn.setAttribute('aria-pressed', nextState);
    btn.setAttribute('aria-label', nextState ? 'Play banner scrolling' : 'Pause banner scrolling');

    const pauseIcon = btn.querySelector('.pause-icon');
    const playIcon = btn.querySelector('.play-icon');

    if (pauseIcon) pauseIcon.classList.toggle('hidden', nextState);
    if (playIcon) playIcon.classList.toggle('hidden', !nextState);
    
    if (nextState) {
      carousel.classList.add('f-scrolling-promotion--paused');
    } else {
      carousel.classList.remove('f-scrolling-promotion--paused');
    }

    const allTracks = carousel.querySelectorAll('.f-promotion--animated');
    allTracks.forEach(track => {
      track.style.setProperty('animation-play-state', nextState ? 'paused' : 'running', 'important');
    });
  }
}, true);